module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_summersale-01f8ca854d28e4c46b5ce0e96fcac78c.png";